import CreativeTagModal from './CreativeTagModal';

export default CreativeTagModal;
